import Client from '@/client'

export default {
  list(offset, limit=20) {
    let query = `{id,uuid,name,owner{id,name},shape,status,users,updated_at}`
    return Client.get(`files/`, { params: { limit: limit, offset: offset, query: query }})
  },
  create(payload) {
    return Client.post(`files/`, payload)
  },
  retrieve(id) {
    return Client.get(`files/${id}/`)
  },
  head(id, start = 0) {
    return Client.get(`files/${id}/head/`, { params: { start: start } })
  },
  info(id) {
    return Client.get(`files/${id}/info/`)
  },
  stats(id, column) { 
    return Client.get(`files/${id}/stats`, { params: { column: column }})
  },
  columns(id) {
    return Client.get(`files/${id}/columns/`)
  },
  uniques(id, column) {
    return Client.get(`files/${id}/uniques/`, { params: { column: column } })
  },
  frame(id) {
    return Client.get(`files/${id}/frame/`)
  },
  update(id, payload) {
    return Client.put(`files/${id}/`, payload)
  },
  refresh(id, payload) {
    return Client.put(`files/${id}/refresh/`, payload)
  },
  compute(id, payload) {
    return Client.put(`files/${id}/compute/`, payload)
  },
  rename(id, payload) {
    return Client.put(`files/${id}/rename/`, payload)
  },
  drop(id, payload) {
    return Client.put(`files/${id}/drop/`, payload)
  },
  clean(id, payload) {
    return Client.put(`files/${id}/clean/`, payload)
  },
  holdback(id, payload) {
    return Client.put(`files/${id}/holdback/`, payload)
  },
  share(id, payload) {
    return Client.post(`files/${id}/share/`, payload)
  },
  clone(id, payload) {
    return Client.post(`files/${id}/clone/`, payload)
  },
  apis(id) {
    return Client.get(`files/${id}/apis/`)
  },
  patch(id, payload) {
    return Client.patch(`files/${id}/`, payload)
  },
  download(id) {
    return Client.get(`files/${id}/download/`)
  },
  destroy(id) {
    return Client.delete(`files/${id}/`)
  },
  delete(payload) {
    return Client.post('files/delete/', payload)
  }
}